// src/components/accordion/AccUserFolderAssignments.tsx

import {
  AddCircleTwoTone,
  ExpandMoreTwoTone,
  FilterListTwoTone,
  RemoveCircleTwoTone,
} from '@mui/icons-material'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  ButtonGroup,
  Collapse,
  IconButton,
  List,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material'

import { FolderPool } from '@/types/domain/folder'

import { FolderListItem, HStack } from '..'
import { useFolderPool } from '../../hooks'

type Props = {
  user: any
  setUser: (_: any) => void
  config: any
  setConfig: (_: any) => void
}

export const AccUserFolderAssignments = ({
  config,
  setConfig,
  user,
  setUser,
}: Props) => {
  const theme = useTheme()
  const color = theme.palette.primary.main

  const fPool: FolderPool = useFolderPool()

  if (!user || !config || !fPool) return null

  const { assignedFoldersOnly, assignmentSection } = config
  const { folders } = user

  // filter

  const FILTER_ASSIGNED_FOLDERS_ONLY = f =>
    assignedFoldersOnly ? folders.find(f2 => f2.entity_id === Number(f.id)) : f

  // handler

  const handleRemoveAll = () => setUser(prev => ({ ...prev, folders: [] }))

  const handleAssignAll = () => {
    const folders = fPool.map(f => f.attributes)

    setUser(prev => ({ ...prev, folders }))
  }

  const handleToggleAssigned = () => {
    setConfig(prev => ({
      ...prev,
      assignedFoldersOnly: !prev.assignedFoldersOnly,
    }))
  }

  return (
    <Collapse in={true} sx={{ mb: 2 }}>
      <Accordion
        expanded={assignmentSection === 0}
        onChange={() => setConfig(prev => ({ ...prev, assignmentSection: 0 }))}
      >
        <AccordionSummary expandIcon={<ExpandMoreTwoTone />}>
          <Typography>
            Gebäude {`(${folders.length}/${fPool.length})`}
          </Typography>
        </AccordionSummary>

        <AccordionDetails>
          <HStack justifyContent={'space-between'}>
            <HStack>
              <ButtonGroup>
                <Tooltip title={'Alle Gebäude entziehen'}>
                  <IconButton onClick={handleRemoveAll}>
                    <RemoveCircleTwoTone />
                  </IconButton>
                </Tooltip>

                <Tooltip title={'Alle Gebäude zuweisen'}>
                  <IconButton onClick={handleAssignAll}>
                    <AddCircleTwoTone />
                  </IconButton>
                </Tooltip>
              </ButtonGroup>
            </HStack>

            <HStack>
              <Tooltip
                title={`Nur zugewiesene Gebäude: ${
                  assignedFoldersOnly ? '' : 'in'
                }aktiv`}
              >
                <IconButton
                  sx={{ bgcolor: assignedFoldersOnly ? color : 'none' }}
                  onClick={handleToggleAssigned}
                >
                  <FilterListTwoTone />
                </IconButton>
              </Tooltip>
            </HStack>
          </HStack>

          <List
            sx={{
              cursor: 'pointer',
              maxHeight: 400,
              overflow: 'auto',
              overflowX: 'hidden',
              width: '100%',
            }}
          >
            {fPool.filter(FILTER_ASSIGNED_FOLDERS_ONLY).map(f => {
              const { attributes, id } = f
              const selected = Boolean(
                folders.find(f => f.entity_id === Number(id))
              )
              const onClick = () =>
                setUser(prev => ({
                  ...prev,
                  folders: !selected
                    ? [...folders, attributes]
                    : folders.filter(f => f.entity_id !== Number(id)),
                }))

              return (
                <FolderListItem
                  id={Number(id)}
                  key={id}
                  onClick={onClick}
                  selected={selected}
                />
              )
            })}
          </List>
        </AccordionDetails>
      </Accordion>
    </Collapse>
  )
}
